export const DEFAULT_DURATIONS = [15, 30, 45, 60]
export const MAX_OPTIONS_COUNT = 4
